import { lazy, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import Loader from "../Components/Loader";
import { getCookie } from "../utils/cookieFuns";
import { getUserRoleByToken } from "../utils/commonFuns";
import Users from "../Pages/Users";
import Reports from "../Pages/Reports";
const Customers = lazy(() => import("../Pages/Customers"));
const ScheduleFines = lazy(() => import("../Pages/ScheduleFine"));
const Transfer = lazy(() => import("../Pages/Transfer"));
const Transactions = lazy(() => import("../Pages/Transactions"));
const BalanceHistory = lazy(() => import("../Pages/BalanceHistory"));
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const SignIn = lazy(() => import("../Pages/SignIn"));
const ErrorBoundary = lazy(() => import("../Pages/ErrorBoundary"));
const MainLayout = lazy(() => import("../Layout/MainLayout"));
const Agents = lazy(() => import("../Pages/Agents"));
const NotFound = lazy(() => import("../Pages/NotFound"));
const ImposedFine = lazy(() => import("../Pages/ImposedFine"));
const VehicleBlackList = lazy(() => import("../Pages/VehicleBlackList"));
const VehicleWarnings = lazy(() => import("../Pages/VehicleWarnings"));

const isLogin = getCookie("session") ?? "";
const role = getUserRoleByToken(isLogin);

const router = createBrowserRouter([
  {
    path: "/",
    element: role ? (
      <ErrorBoundary>
        <MainLayout>
          <Suspense
            fallback={
              <div className="w-full flex items-center justify-center p-4">
                <Loader size={20} />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </MainLayout>
      </ErrorBoundary>
    ) : (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <SignIn />
        </Suspense>
      </ErrorBoundary>
    ),
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "agents",
        element: <Agents />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "schedule-offcenses",
        element: <ScheduleFines />,
      },
      {
        path: "transfer",
        element: <Transfer />,
      },
      {
        path: "transactions",
        element: <Transactions />,
      },
      {
        path: "balance-history",
        element: <BalanceHistory />,
      },
      {
        path: "imposed-fines",
        element: <ImposedFine />,
      },
      {
        path: "reports",
        element: <Reports />,
      },
      {
        path: "vehicle-blacklist",
        element: <VehicleBlackList />,
      },
      {
        path: "vehicle-warnings",
        element: <VehicleWarnings />,
      },
    ],
  },
  {
    path: "/SignIn",
    element: <SignIn />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
